import styled from 'styled-components'
import { useLoading } from 'components/Loading'
import { StyledRoot } from 'components/SectionHandler/ItemActions/styled'

export const ButtonContainer = styled.div`
	padding: 0 8px;
	cursor: pointer;
	position: relative;
	svg {
		path, g { fill: ${props => props.theme.activeColor} }
		circle { stroke: ${props => props.theme.activeColor}; }
		width: 24px;
		height: 24px;
	}
	&:hover::after {
		position: absolute;
		content: '${props => props.tooltip}';
		bottom: -2.5em;
		right: -1em;
		background-color: ${props => props.theme.primaryColor};
		color: white;
		padding: .25em .5em;
		font-size: .8em;
		z-index: 300;
	}
`

export const StyledMenuBar = styled.div`
	display: flex;
	align-items: center;
  justify-content: space-between;
	background: ${props => props.theme.primaryColor};
	height: 36px;
	width: 100%;
	padding: 0 12px;

	${StyledRoot} {
		z-index: 101;
	}
`

export const StyledMenuSubgroup = styled.div`
	display: flex;
	align-items: center;
  justify-content: space-between;
  width: ${({ width }) => width}
`

export const StreamContainer = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	flex-direction: column;
	background-color: ${({ theme }) => theme.darkbgColor};
	box-shadow: 0 2px 2px 0 rgba(90, 90, 90, 0.2);
	video {
		height: auto;
    width: auto;
    max-width: 100%;
    max-height: 720px;
    min-height: 400px;
	}
`

export const StreamLoader = styled.div`
	${useLoading}
	display: ${props => props.isLoading ? 'block' : 'none'};
	width: 100%;
  height: 100%;
  position: absolute;
  &:after {
  	background-color: rgba(244,244,244,0.56);
  	padding-bottom: 36px;
  }

`

export const StreamRestarter = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	position: absolute;
	width: 100%;
	height: 100%;
	background-color: rgba(244,244,244,0.56);
	font-size: 24px;
	padding-bottom: 36px;
	div {
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 10;
	}
`

export const StatusText = styled.div`
  color: #fff;
  font-size: 16px;
  position: absolute;
  border-radius: 20px;
  background: rgb(0 0 0 / 50%);
  padding: 8px 20px;
  min-width: 300px;
  text-align: center;
  z-index: 100;
  bottom: 60px;
`
